import { atom, useAtom } from "jotai";

export const isOptionHedgedAtom = atom<boolean>(false);

export const useIsOptionHedged = () => {
  const [isOptionHedged, setIsOptionHedged] = useAtom(isOptionHedgedAtom);

  return {
    isOptionHedged,
    setIsOptionHedged,
  };
};
